var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Menu',{on:{"tab_selected":_vm.onTabSelected}}),_c('Content',{attrs:{"selected_tab":_vm.current_tab_selection}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }